import { PRD3030_R01Dto, PRD3030_R01ProductResultLotDto } from "./Dto_PRD3030_R01";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { PRD3030_R01Filter } from "./Store_PRD3030_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/PRD3030_R01`;

const getParams = (filter: Partial<PRD3030_R01Filter>, listLength?: number) => {
	return {
		compCd: filter.compCd,
		startDate: filter.productDateRange?.from ? formatDate(filter.productDateRange.from) : undefined,
		endDate: filter.productDateRange?.to ? formatDate(filter.productDateRange.to) : undefined,
		orderType: filter.orderType,
		workplaceCd: filter.workplaceCd,
		itemCd: filter.itemCd,
		brandCd: filter.brandCd,
		listLength: listLength || 0
	}
}

// 생산 실적 리스트 조회 (검색 조건 포함)
export const getPRD3030_R01List = async (option: string, params: Partial<PRD3030_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<PRD3030_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getPRD3030_R01AllCount = async (params: Partial<PRD3030_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}

// 신규 등록
export const createPRD3030_R01 = async (data: PRD3030_R01Dto) => {
	return await postData<PRD3030_R01Dto, ResponseDto<any>>(baseUrl, data);
}

// 수정 (백엔드에서 PATCH 사용)
export const updatePRD3030_R01 = async (data: PRD3030_R01Dto) => {
	return await putData<PRD3030_R01Dto, ResponseDto<any>>(baseUrl, data);
}

// 삭제 - Path parameter 사용
export const deletePRD3030_R01 = async (productResultNo: string) => {
	return await deleteData<void>(`${baseUrl}/${productResultNo}`);
}

// 엑셀 다운로드
export const exportPRD3030_R01Excel = async (option: string, params: Partial<PRD3030_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`;

	const requestParams = {
		compCd: params?.compCd,
		startDate: params?.productDateRange?.from ? formatDate(params.productDateRange.from) : undefined,
		endDate: params?.productDateRange?.to ? formatDate(params.productDateRange.to) : undefined,
		orderType: params?.orderType,
		workplaceCd: params?.workplaceCd,
		itemCd: params?.itemCd,
		brandCd: params?.brandCd
	}
	return await getData<ResponseDto<string>>(url, { params: { ...requestParams, listLength } });
}

// LOT 조회 - 생산실적번호로 생산입고된 LOT 목록 조회
export const getPRD3030_R01LotList = async (productResultNo: string) => {
	const url = `${baseUrl}/lot/${productResultNo}`;
	return await getData<ResponseDto<PRD3030_R01ProductResultLotDto[]>>(url);
}
